import { createElement, useCallback, useContext } from 'react';
import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { OpenAppQrModal } from '../components/common/OpenAppQrModal';
import { ModalContext } from '../contexts/ModalContext';

function redirectToStore() {
  if (isIOS) {
    window.location.href =
      'https://apps.apple.com/kr/app/%EC%82%AC%EC%9A%B4%EB%93%9C%ED%95%84/id6450494947';
  } else if (isAndroid) {
    window.location.href =
      'https://play.google.com/store/apps/details?id=info.digitalnutrition.soundpill2&hl=ko-KR';
  }
}

export function useOpenApp() {
  const { handleModal } = useContext(ModalContext);

  return useCallback(() => {
    if (isMobile) {
      redirectToStore();
    } else {
      handleModal(createElement(OpenAppQrModal));
    }
  }, [handleModal]);
}
